var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProduct(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 179.057,
    height: 141.542,
    viewBox: "0 0 179.057 141.542",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74.502,
    height: 89.127,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_936",
    "data-name": "Ellipse 936",
    cx: 28.389,
    cy: 28.389,
    r: 28.389,
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "order",
    transform: "translate(-1036 -620.837)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5167",
    "data-name": "Path 5167",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, -4236.396, 15001.654)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5169",
    "data-name": "Path 5169",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "translate(-13301.297 5731.177) rotate(60)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5168",
    "data-name": "Path 5168",
    d: "M2837.58-15100.612l-1.806,9.027",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, -9981.246, 11177.643)",
    fill: "none",
    stroke: "#e8e8e8",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3850",
    "data-name": "Group 3850",
    transform: "translate(-1981.83 15831.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_9456",
    "data-name": "Rectangle 9456",
    d: "M16,0H97.987a16,16,0,0,1,16,16V129.4a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V16A16,16,0,0,1,16,0Z",
    transform: "translate(3042.847 -15202.371)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9450",
    "data-name": "Rectangle 9450",
    transform: "translate(3050.316 -15195.53)",
    fill: "#fff",
    stroke: "#343434",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0H97.987a16,16,0,0,1,16,16V125.163a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V16A16,16,0,0,1,16,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1.5H97.987a14.5,14.5,0,0,1,14.5,14.5V122.163a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5V16A14.5,14.5,0,0,1,16,1.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_6",
    "data-name": "Repeat Grid 6",
    transform: "translate(3070.432 -15173.179)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4164 11369)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9452",
    "data-name": "Rectangle 9452",
    width: 70,
    height: 14,
    rx: 7,
    transform: "translate(-4164 -11369)",
    fill: "rgba(0,0,0,0.09)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4164 11401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9452-2",
    "data-name": "Rectangle 9452",
    width: 70,
    height: 14,
    rx: 7,
    transform: "translate(-4164 -11369)",
    fill: "rgba(0,0,0,0.09)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4164 11433)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9452-3",
    "data-name": "Rectangle 9452",
    width: 70,
    height: 14,
    rx: 7,
    transform: "translate(-4164 -11369)",
    fill: "rgba(0,0,0,0.09)"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_937",
    "data-name": "Ellipse 937",
    cx: 37.623,
    cy: 37.623,
    r: 37.623,
    transform: "translate(3091.311 -15188.816)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_935",
    "data-name": "Ellipse 935",
    transform: "translate(3096.508 -15186.59)",
    fill: "#fff",
    stroke: "#343434",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.623,
    cy: 37.623,
    r: 37.623,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.623,
    cy: 37.623,
    r: 36.123,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5164",
    "data-name": "Path 5164",
    d: "M-4244.6-11230h179.057",
    transform: "translate(7262.427 -3841.12)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_934",
    "data-name": "Ellipse 934",
    transform: "translate(3105.742 -15177.355)",
    fill: "none",
    stroke: "#343434",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.389,
    cy: 28.389,
    r: 28.389,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.389,
    cy: 28.389,
    r: 26.889,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9451",
    "data-name": "Rectangle 9451",
    transform: "translate(3160.392 -15109.504) rotate(-48)",
    fill: "#fff",
    stroke: "#343434",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9,
    height: 25.331,
    rx: 7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 11.9,
    height: 22.331,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5165",
    "data-name": "Path 5165",
    d: "M-4044.025-11298.191l7.414,6.765,3.054-3.415-6.876-6.629Z",
    transform: "translate(7200.86 -3821.399)",
    fill: "#fff",
    stroke: "#343434",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_293",
    "data-name": "Mask Group 293",
    transform: "translate(3105.742 -15177.355)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9453",
    "data-name": "Rectangle 9453",
    width: 56.06,
    height: 15.812,
    rx: 7.906,
    transform: "translate(-12.937 17.249)",
    fill: "rgba(0,0,0,0.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9454",
    "data-name": "Rectangle 9454",
    width: 56.06,
    height: 15.812,
    rx: 7.906,
    transform: "translate(-17.249 37.373)",
    fill: "rgba(0,0,0,0.09)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3849",
    "data-name": "Group 3849",
    transform: "translate(3130.778 -15162.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5166",
    "data-name": "Path 5166",
    d: "M1.49,0H5.96A1.49,1.49,0,0,1,7.45,1.49L5.989,19.5c0,.823-.416,1.2-1.239,1.2H2.982c-.823,0-1.721-.38-1.721-1.2L0,1.49A1.49,1.49,0,0,1,1.49,0Z",
    transform: "translate(0)",
    fill: "#ff091b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9455",
    "data-name": "Rectangle 9455",
    width: 4.47,
    height: 2.98,
    rx: 1,
    transform: "translate(1.49 22.605)",
    fill: "#ff091b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProduct);
export default __webpack_public_path__ + "static/media/no_product.be6c2ce5c6cc655b2fdedf81dc74fa67.svg";
export { ForwardRef as ReactComponent };